import { ContentSections, useContentBlocks } from '../components/content/ContentSections';
import { StaticPageLayout } from '../components/layout/StaticPageLayout';

const REFUND_UPDATED = '2026-10-20';

export function RefundPolicyPage() {
  const blocks = useContentBlocks('staticPages.refund.blocks');

  return (
    <StaticPageLayout
      titleKey="staticPages.refund.title"
      subtitleKey="staticPages.refund.subtitle"
      lastUpdatedKey="staticPages.refund.lastUpdated"
      date={REFUND_UPDATED}
    >
      <ContentSections blocks={blocks} />
    </StaticPageLayout>
  );
}
